import React, { useEffect, useState } from 'react';
import './Solutions.css'; // you can style it here
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust based on your structure

import factoids from '../../info/factoids';
import FactoidSection from '../../components/FactoidSection';

// AI
// Data Center
// Central Office & Headend
// Outside plant
// FTTx & MDU
// Rural Broadband
// Wireless
// Enterprise
// Medical Imaging
// Neuroscience
// Optoelectronics
// Specialty Optics
// Optical Equipment

const slides = [
  {
    video: "/videos/solutionSpecialtyOptics.mp4",
    poster: "/videos/solutionSpecialtyOptics.jpg",
    heading: "See Further, Discover Faster: Specialty Optics Engineered for Innovation",
    subheading: "Delivering high-performance and driving breakthroughs",
    buttonLink: "/solutions"
  }
];

function SolutionSpecialtyOptics() {

  const [products, setProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [activeFilter, setActiveFilter] = useState('All');


const productFamilies = [
  'Passive Optical Components',
  'Lenses',
  'Photodetectors'
];

  const [industryFilter, setIndustryFilter] = useState('Central Office & Headends')

useEffect(() => {
  const loadProducts = async () => {
    const querySnapshot = await getDocs(collection(db, 'products'));
    const allProducts = querySnapshot.docs
      .map(doc => ({ id: doc.id, ...doc.data() }))
      .filter(p => (p["Include Y or N"] || '').trim().toUpperCase() !== 'N');

    setProducts(allProducts);
    setFilteredProducts(allProducts); // Default to all
  };

  loadProducts();
}, []);

const topByFamily = productFamilies.map(famName => {
  const matchingProducts = filteredProducts.filter(
    p => (p.productFamily || '').trim() === famName
  );
  if (matchingProducts.length === 0) return null;

  const topProduct = matchingProducts.reduce((best, current) =>
    Number(current.rank ?? Infinity) < Number(best.rank ?? Infinity) ? current : best
  );

  return { family: famName, topProduct };
}).filter(Boolean); // remove nulls if a family has no products

const [familyIndex, setFamilyIndex] = useState(0);
const [familySlidesPerView, setFamilySlidesPerView] = useState(3);

useEffect(() => {
  const update = () => {
    if (window.innerWidth <= 768) {
      setFamilySlidesPerView(1);
    } else if (window.innerWidth <= 1100) {
      setFamilySlidesPerView(2);
    } else {
      setFamilySlidesPerView(3);
    }
  };

  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const familyMaxIndex = Math.max(topByFamily.length - familySlidesPerView, 0);

const nextFamily = () => {
  setFamilyIndex(prev => Math.min(prev + 1, familyMaxIndex));
};

const prevFamily = () => {
  setFamilyIndex(prev => Math.max(prev - 1, 0));
};

useEffect(() => {
  if (activeFilter === 'All') {
    setFilteredProducts(products);
  } else {
    setFilteredProducts(products.filter(p => p.productFamily === activeFilter));
  }
}, [activeFilter, products]);

  return (
    <div className="contact-page">
      <div className="single-marquee">
        <div className="single-marquee-slide">
          <video
            disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback"
            src={slides[0].video}
            poster={slides[0].poster}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="single-overlay-content">
            <h1>{slides[0].heading}</h1>
            <p>{slides[0].subheading}</p>
            <a href={"/support"} className="cta-button">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      <svg className="section-divider" viewBox="0 0 1440 150" preserveAspectRatio="none">
  <defs>
    <linearGradient id="hardWhiteSplit" x1="0" y1="0" x2="0" y2="1">
      <stop offset="50%" stopColor="white" stopOpacity="1" />
    </linearGradient>
  </defs>
  <path
    d="
      M0,150
      H1440
      V0
      Q720,75 0,0
      Z
    "
    fill="url(#hardWhiteSplit)"
  />
</svg>

      <div className="solutions-section-1" style={{marginTop: 60}}>
        <div className="solutions-section-1-image-container">
          <img src="/images/solutions/specialtyOptics.jpeg" alt="Specialty Optics" />
        </div>

        <div className="solutions-section-1-text-container">
          <h2 className="solutions-section-1-subheading">Clarity Beyond Limits: Optical Solutions for Advanced Fiber Systems</h2>
          <p className="solution-section-1-description">When photons power discovery, the quality of your optics determines the clarity of your results. From university labs to commercial laser platforms, our Specialty Optics solutions bring unmatched accuracy and reliability to applications like microscopy, silicon photonics, and precision photonic detectors. In a landscape where every nanometer matters, Go!Foton designs optical components that elevate accuracy, endurance, and long-term performance.</p>
        </div>
      </div>

      <div style={{ backgroundColor: '#f9f9f9'}}>
      <div className="solutions-section-factoids">
        {/* <h2 className="solutions-section-factoids-header">
          Precision fiber engineering for high-power performance.
        </h2>

        <div className="solutions-section-factoid-grid">
          <div className="solutions-section-factoids-box" style={{ backgroundColor: '#8C277B' }}>
            <p className="solutions-section-factoid-text">Global bandwidth demand continues to double approximately every <span className="largerText">2 years</span>, driven by video and cloud.</p>
            <p className="solutions-section-factoid-source">Source: <a href="#">Cisco</a></p>
          </div>

          <div className="solutions-section-factoids-box" style={{ backgroundColor: '#24BFBF' }}>
            <p className="solutions-section-factoid-text"><span className="largerText">74%</span> of MSOs are investing in fiber-rich architectures to support 10G and multi-gig services.</p>
            <p className="solutions-section-factoid-source">Source: <a href="#">Light Reading</a></p>
          </div>

          <div className="solutions-section-factoids-box" style={{ backgroundColor: '#D94929' }}>
            <p className="solutions-section-factoid-text">Over <span className="largerText">50%</span> of telecom operators plan to virtualize Headend functions by 2026.</p>
            <p className="solutions-section-factoid-source">Source: <a href="#">Heavy Reading</a></p>
          </div>

          <div className="solutions-section-factoids-box" style={{ backgroundColor: '#8FC54B' }}>
            <p className="solutions-section-factoid-text">Over <span className="largerText">70%</span> of telecom providers are actively upgrading central offices to support higher bandwidths and AI-driven applications.</p>
            <p className="solutions-section-factoid-source">Source: <a href="#">Fiber Broadband</a></p>
          </div>
        </div> */}
      </div>
      </div>


      <div className="solutions-section-checklist">
        <div className="solutions-section-checklist-left">
          
          <div className="solutions-section-checklist-image-wrapper">
            <img src="/images/solutions/specialtyOptics2.jpeg" alt="Central Office" />
          </div>
        </div>

        <div className="solutions-section-checklist-right">
          <h2 className="solutions-section-checklist-heading">Precision Fiber Engineering for High-Power Performance</h2>
          <p className="solutions-section-checklist-description">When precision meets power, Go!Foton delivers. Our TEC Fiber and Tapered Fiber Power Combiners offer unmatched coupling efficiency, low noise, and robust thermal stability, making them ideal for high-performance laser applications, optical sensors, and advanced photonic systems. Built for stability and scalability, these solutions ensure consistent results in environments where optical clarity drives innovation.</p>
          <ul className="solutions-section-checklist-points">
            <li>Robust Optical Performance</li>
            <li>Low Insertion Loss</li>
            <li>Durable Construction</li>
            <li>Improved efficiency</li>
            <li>Custom Tailored for Your Unique Application</li>
          </ul>
        </div>
      </div>


    <section className="solution-products-section">
      <h2>Optics you can trust</h2>
      <p className="solution-products-section-description">Our innovative Specialty Optics solutions provide high-precision craftsmanship, reliable performance, and application-specific designs ready to deliver, no matter the challenge.</p>



<div className="products-grid">
  {topByFamily.map(({ family, topProduct }) => (
    <div key={family} className="product-card">
      {topProduct.image ? (
        <img
          src={topProduct.image}
          alt={family}
          style={{ width: '100%', height: 200, objectFit: 'cover' }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: 215,
            backgroundColor: '#ddd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontStyle: 'italic',
            color: '#666',
          }}
        >
          No Image Available
        </div>
      )}
      <h3>{family}</h3>
      <a
        href={`/${family.toLowerCase().replace(/\s+/g, '-')}`}
        className="learn-more"
      >
        Learn More
      </a>
    </div>
  ))}
</div>

    </section>


        <div className="curved-footer-solutions">
        <div className="curved-top-overlay-solutions"></div>
        
        <h2>Would you like to hear more?</h2>
        <p>Our experts would love to hear about your systems and how we can help</p>
        <a className="connect-button" href="/support">LET’S CONNECT</a>
        </div>

    </div>

    
  );
}

export default SolutionSpecialtyOptics;
